import dayjs from "dayjs";

export const formatDate = (
  date: Date | null,
  config: { format: string } = { format: "ddd D MMM" },
) => {
  if (!date) {
    return "Unknown date";
  }
  return dayjs(date).format(config.format);
};
